<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <el-form :model="query" ref="queryForm" :inline="true">
          <div class="flexs justify-between">
            <el-form-item label="下单时间：" class="is-required">
              <el-date-picker v-model="busTime" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始时间" end-placeholder="结束时间" clearable></el-date-picker>
            </el-form-item>
            <el-form-item label="时间粒度：" prop="timeType" class="is-required">
              <el-select v-model="query.timeType" placeholder="请选择" clearable size="small">
                <el-option label="自然月" :value="3"></el-option>
                <el-option label="自然周" :value="2"></el-option>
                <el-option label="自然日" :value="1"></el-option>
                <el-option label="年" :value="5"></el-option>
                <el-option label="季度" :value="4"></el-option>
              </el-select>
            </el-form-item>
          </div>

          <el-form-item label="区域：">
            <el-cascader v-model="query.addressArray" @change="changeCascader" :props="cascaderProps" collapse-tags :options="regionOptions" :show-all-levels="false" clearable placeholder="请选择所属区域" size="small"></el-cascader>
          </el-form-item>
          <el-form-item label="收款类别：">
            <el-select v-model="query.type" placeholder="请选择" clearable size="small">
              <el-option :label="item.label" :value="item.value" v-for="item in collectionOption" :key="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="客户类型：">
            <el-select v-model="query.isCustomerXin" placeholder="请选择" clearable size="small">
              <el-option label="新客户" :value="0"></el-option>
              <el-option label="老客户" :value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="客户分类：">
            <el-select v-model="query.customerClassifyId" placeholder="请选择" filterable clearable size="small">
              <el-option v-for="(item,index) in options.customerClass" :key="index" :label="item.value" :value="item.key"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="部门：">
            <el-select v-model="query.performanceUserId" placeholder="请选择" filterable clearable size="small" @change="changDepartment">
              <el-option v-for="(item,index) in options.departmentList" :key="index" :label="item.name" :value="item.directorUserId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="技术/业务级别：">
            <el-select v-model="query.levelName" placeholder="请选择" filterable clearable size="small" @change="changeFormanceUserType">
              <el-option v-for="(item,index) in options.levelOptions" :key="index" :label="item.levelName" :value="item.levelName"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="人员信息：" prop="nameOrPho">
            <el-select v-model="query.nameOrPho" placeholder="手机号模糊查询" remote :remote-method="searchUsers" :loading="loading" filterable clearable size="small" @change="changeUser">
              <el-option v-for="(item,index) in options.selectOptions" :key="index" :label="item.name" :value="item.pho"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="fr">
            <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
            <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <template v-if="isShowEcharts">
        <echarts-vue :echart-data="echartData" echartName="echarts" v-if="echartData && echartData.yAxisData" />
      </template>
      <template v-if="list && list.length > 0">
        <el-table v-loading="listLoading" :data="list">
          <el-table-column label="用户信息" prop="name" align="center" fixed />
          <el-table-column label="用户身份" prop="levelName" align="center" fixed />
          <el-table-column label="用户手机号" prop="pho" align="center" fixed width="120" />
          <el-table-column label="客户分类" prop="classifyName" align="center" />
          <el-table-column label="收款类型" prop="payType" align="center" />
          <el-table-column align="center" :label="item + '收款(元)/占比'" v-for="(item, index) in newTableTitle" :key="index" width="150px">
            <template slot-scope="{row}">
              {{ row['money' + index] }}({{ row['ratio' + index]}}%)
            </template>
          </el-table-column>
          <el-table-column label="累计收款(元)/占比" prop="allMoney" align="center" width="140" fixed="right" />
        </el-table>
        <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
      </template>
    </el-card>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import customerClassifyApi from '@/api/config/customerClassify'
import echartsVue from "../components/echarts.vue";
import sysDepartmentApi from '@/api/config/sysDepartment'
import customerApi from '@/api/technical/customer'
import technicianInfoApi from '@/api/technical/technicianInfo'
import DataBoardApi from '@/api/dataBoard/DataBoard'
import customerLevelApi from '@/api/sys/customerLevel'
import { Subtr, formatDate, getCurrentMonthEnd, get6MonthStart } from '@/utils/index'
export default {
  components: {
    Pagination,
    echartsVue
  },
  data() {
    return {
      list: [],
      listLoading: true,
      total: 0,
      query: {
        pageNo: 1,
        pageSize: 10,
        timeType: 3,
        performanceUserId: '',
        performanceUserType: undefined
      },
      cascaderProps: {
        label: 'regionName',
        value: 'regionCode',
        children: 'child'
      },
      minDate: '',  //这两个值一定要定义
      maxDate: '',
      busTime: [],
      executeTimeOptions: {
        disabledDate: (time) => {
          if (this.minDate && this.maxDate) {
            //  this.maxDate  = new Date(this.maxDate).getTime();我是直接获取的时间戳，如果后台返回的格式不同，因为这里是对比的时间戳，所以在这里转换格式或者获取的时候转换成时间戳都可以,
            return time.getTime() < Date.now() - 8.64e7 || time.getTime() > this.maxDate || time.getTime() < this.minDate;
            //这里是大于结束日期和小于开始日期，小于今天的日期都不可选择
          }
        }
      },
      options: {
        customerClass: [],
        departmentList: [],
        customerKFOptions: [],
        selectOptions: [],
        levelOptions: []
      },
      collectionOption: [{ value: 1, label: '学费(体验班)' }, { value: 2, label: '学费(研修班)' }, { value: 3, label: '二次进货款' },
      { value: 4, label: '政策（秒杀订单）' }, { value: 5, label: '充值' }, { value: 6, label: '会议收款（线下会议）' }, { value: 7, label: '线上课程' }],
      addressList: [],
      customerClassifyOption: [],
      regionOptions: [],
      newTableTitle: [],
      isShowEcharts: false,
      xData: []
    }
  },

  created() {
    this.getCustomerClass()
    this.getDepOption()
    this.getDate()
    this.getAllLevel()
    let regionOptions = JSON.parse(localStorage.getItem('addressTree')) || [];
    this.regionOptions = this.formatCascaderData(regionOptions)
  },
  methods: {
    getAllLevel() {
      customerLevelApi.getAllLevel({ getTechnicianLevel: true, getYeWuLevel: true, getCustomerLevel: false }).then(res => {
        this.options.levelOptions = res.data
      })
    },
    changeFormanceUserType() {
      this.$set(this.query, 'nameOrPho', '')
      let find = this.options.levelOptions.find(item => item.levelName === this.query.levelName)
      if (find) this.query.performanceUserType = find.type
      this.options.selectOptions = []
    },
    handleFilter() {
      this.query = {
        pageNo: 1,
        pageSize: 10,
        timeType: 3,
        performanceUserId: ''
      }
      this.getDate()
    },
    formatCascaderData(data) {
      for (var i = 0; i < data.length; i++) {
        if (data[i].child.length < 1) {
          // children若为空数组，则将children设为undefined
          data[i].child = undefined;
        } else {
          // children若不为空数组，则继续 递归调用 本方法
          this.formatCascaderData(data[i].child)
        }
      }
      return data
    },
    changeCascader() {
      let { addressArray } = this.query;
      this.query.addrProvinceCode = addressArray[0]
      this.query.addrCityCode = addressArray[1]
      this.query.addrAreaCode = addressArray[2]
    },
    getDate() {
      let minDate = formatDate(get6MonthStart(5)) + ' 00:00:00'
      let maxDate = formatDate(getCurrentMonthEnd()) + ' 23:59:59'
      this.busTime = [minDate, maxDate]
    },
    // 获取部门
    getDepOption() {
      sysDepartmentApi.fetchList({ pageNo: 1, pageSize: 1000 }).then(({ data }) => {
        this.options.departmentList = data.list
      })
    },
    //获取客户分类
    getCustomerClass() {
      customerClassifyApi.findOptions().then(res => {
        this.options.customerClass = res.data.reverse()
      })
    },
    searchUsers(query) {
      if (query !== '') {
        this.loading = true;
        // 模拟远程搜索，实际应用中应该是发起AJAX请求
        setTimeout(() => {
          this.loading = false;
          this.searchVal = query
          this.getKFCustomer()
          this.$set(this.query, 'nameOrPho', null)
        }, 500);
      } else {
        this.options = [];
      }
    },
    getKFCustomer() {

      let { levelName } = this.query;
      let find = this.options.levelOptions.find(item => item.levelName === levelName)
      DataBoardApi.getUserInfo({ levelId: find.levelId, nameOrPho: this.searchVal, levelType: find.type }).then(({ data }) => {
        this.options.selectOptions = data
      })
    },
    calcQuery() {
      let params = JSON.parse(JSON.stringify(this.query))
      if (this.busTime && this.busTime.length) {
        params.startTime = this.busTime[0]
        params.endTime = this.busTime[1]
      }
      delete params.levelName
      delete params.addressArray
      return params
    },
    doQueryList({ pageNo, pageSize }) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }
      let params = this.calcQuery()
      this.listLoading = true
      return DataBoardApi.payStatisticsList(params)
        .then(data => {
          let { list, total } = data.data
          list && list.forEach(item => {
            let money = 0;
            item.moneyList.forEach((it, idx) => {
              money = Subtr(money, -it.money)
              item['money' + idx] = it.money
            })
            item.allMoney = money
          })
          this.newTableTitle = this.calcTableTitle(list)
          this.list = list || []
          this.calcRatio()
          this.total = total
        }).finally(() => {
          this.listLoading = false
        })
    },
    calcRatio() {
      this.list.forEach(item => {
        item.moneyList.forEach((it, idx) => {
          item['ratio' + idx] = item.allMoney ? (it.money / item.allMoney * 100).toFixed(2) : 100
        })
      })
    },
    calcTableTitle(list) {
      if (!list.length) return
      if (!list[0].moneyList) return
      let data = list[0].moneyList || []
      let { timeType } = this.query;
      let dateList = []
      // 1日2周3月4季度5年
      if (timeType === 1) {
        data.forEach((item, index) => {
          item.date = item.startTime.substr(0, 10).replace(/\-/g, "/")
        });
        dateList = data.map(item => item.date)
      } else if (timeType === 2) {
        data.forEach((item, index) => {
          let date = item.startTime.substr(0, 10).replace(/\-/g, "/")
          dateList.push(`第${index + 1}周 ${date}`)
        });

      } else if (timeType === 3) {
        data.forEach(item => {
          let date = item.startTime.substr(5, 2)
          dateList.push(`${date}月`)
        });
      } else if (timeType === 4) {
        data.forEach((item, index) => {
          let date = item.startTime.substr(0, 7).replace(/\-/g, "/")
          dateList.push(`第${index + 1}季度 ${date}`)
        });
      } else if (timeType === 4) {
        data.forEach((item, index) => {
          item.date = item.startTime.substr(0, 4).replace(/\-/g, "/")
        });
        dateList = data.map(item => item.date)
      }
      return dateList
    },
    changDepartment() {
      let { performanceUserId } = this.query;
      let find = this.options.departmentList.find(item => item.directorUserId === performanceUserId)
      if (find) this.query.performanceUserType = find.directorUserType === 30 ? 1 : 2
    },
    getPaymentStatis() {
      let params = this.calcQuery()
      delete params.pageNo
      delete params.pageSize
      DataBoardApi.payStatistics(params).then(({ data }) => {
        if (data.length > 0) {
          // data.forEach(item => {
          //   item.ratio = Subtr(item.afterMoney, item.beforeMoney) / item.beforeMoney * 100;
          // })
          this.calcDate(data)
          this.getEcharts(data)
          this.isShowEcharts = true
        } else {
          this.isShowEcharts = false
          this.$message.warning('暂无数据')
        }
      })
    },
    getEcharts(echartsData) {
      this.echartsData = this.synthesisSeriesData(echartsData, [
        { name: "当前", color: "#FED15C", key: "money" },
        { name: "环比", color: "#F3715B", key: "huanBiMoney" },
        { name: "同比", color: "#8CDFFF", key: "tongBiMoney" },
      ], "line")
      console.log(333333333333, this.echartsData)
    },
    calcDate(data) {
      let { timeType } = this.query;
      let dateList = []
      // 1日2周3月4季度5年
      if (timeType === 1) {
        data.forEach((item, index) => {
          item.date = item.startTime.substr(0, 10).replace(/\-/g, "/")
        });
        dateList = data.map(item => item.date)
      } else if (timeType === 2) {
        data.forEach((item, index) => {
          let date = item.startTime.substr(0, 10).replace(/\-/g, "/")
          dateList.push(`第${index + 1}周 ${date}`)
        });

      } else if (timeType === 3) {
        data.forEach(item => {
          item.date = item.startTime.substr(0, 7).replace(/\-/g, "/")
        });
        dateList = data.map(item => item.date)
      } else if (timeType === 4) {
        data.forEach((item, index) => {
          let date = item.startTime.substr(0, 7).replace(/\-/g, "/")
          dateList.push(`第${index + 1}季度 ${date}`)
        });
      } else if (timeType === 4) {
        data.forEach((item, index) => {
          item.date = item.startTime.substr(0, 4).replace(/\-/g, "/")
        });
        dateList = data.map(item => item.date)
      }
      console.log(1111111111, dateList)
      this.xData = dateList
    },
    //合成图标Y轴信息
    synthesisSeriesData(datalist, ydata, chartType) {
      console.log(222222222, datalist)
      let param = {}, itemStyle = {};
      if (chartType === 'line') {
        param = { type: "line", smooth: true, symbolSize: 10 };
      }
      return ydata.map(item => {
        return {
          name: item.name, ...param, data: datalist.map(it => it[item.key]), itemStyle: {
            ...itemStyle,
            color: item.color
          }
        }
      })
    },
    handleQuery() {
      let { timeType } = this.query;
      if (!this.busTime || (this.busTime && !this.busTime.length)) return this.$message.warning('请选择下单时间')
      if (!timeType) return this.$message.warning('请选择时间粒度')
      this.submitForm()
    },
    submitForm() {
      this.$refs["queryForm"].validate((valid) => {
        if (valid) {
          this.doQueryList({})
          this.getPaymentStatis()
        }
      })
    },
  },
  computed: {
    echartData() {
      return {
        // legendData: item.dataList.map(it => it.title),
        xAxisData: this.xData,
        yAxisData: this.echartsData
      };
    },
  },
}
</script>
<style lang="scss" scoped>
</style>
